export function join(a, b) {
  const lastIndex = a.length - 1;
  const first = a[lastIndex] === '/' ? a.substr(0, lastIndex) : a;
  const second = b[0] === '/' ? b.substr(1) : b;
  return `${first}/${second}`;
}
